<template>
  <div class="search-container" ref="searchContainer">
    <div
      :class="[
        label ? 'input--margin' : '',
        'flex align-center input--wrrapper'
      ]"
    >
      <input
        type="text"
        v-model="query"
        @input="$emit('input', $event.target.value)"
        @focus="showSuggestions"
        :placeholder="placeholder"
      />
      <div class="isLoading" v-if="isLoading"></div>
      <span
        v-if="reset && !isLoading"
        class="cursor mdi mdi-24px mdi-close reset-icon"
        @click="handleReset"
      ></span>
      <span
        v-if="icon"
        :class="`cursor mdi mdi-24px ${icon} input--icon`"
        @click="handleSearch"
      ></span>
    </div>
    <ul
      v-if="showList && suggestions.length"
      class="suggestions"
      ref="suggestionsList"
    >
      <li
        v-for="(suggestion, index) in suggestions && suggestions"
        :key="index"
        @click="selectSuggestion(suggestion)"
      >
        {{ suggestion.name }} / {{ suggestion.fatherOrHusbandName }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: [
    "suggestions",
    "placeholder",
    "icon",
    "isLoading",
    "handleReset",
    "handleSearch",
    "label",
    "reset"
  ],
  data() {
    return {
      query: "",
      showList: false
    };
  },
  watch: {
    suggestions(newSuggestions) {
      if (newSuggestions && newSuggestions.length) {
        this.showList = true;
      }
    },
    handleReset() {
      this.query = "";
    }
  },
  mounted() {
    document.addEventListener("click", this.handleOutsideClick);
  },

  beforeUnmount() {
    document.removeEventListener("click", this.handleOutsideClick);
  },
  methods: {
    handleOutsideClick(event) {
      const target = event.target;
      const searchContainer = this.$refs.searchContainer;
      const suggestionsList = this.$refs.suggestionsList;

      if (
        searchContainer &&
        !searchContainer.contains(target) &&
        suggestionsList &&
        !suggestionsList.contains(target)
      ) {
        this.hideSuggestions();
      }
    },
    showSuggestions() {
      if (this.query) {
        this.showList = true;
      }
    },
    hideSuggestions() {
      this.showList = false;
    },
    selectSuggestion(suggestion) {
      this.$emit("suggestion", suggestion);
      this.query = suggestion.name;
      this.hideSuggestions();
    }
  }
};
</script>

<style>
.search-container {
  position: relative;
}

.search-container input[type="text"] {
  flex: 1 1 auto;
  width: 200px;
  min-width: 0;
  padding: 0 8px;
  outline: none;
  background: transparent;
  box-sizing: border-box;
  font-size: var(--fs-body);
  line-height: 1.4;
  letter-spacing: 0;
  color: var(--text);
  margin: 0;
  border: none;
  font-family: var(--font-sans);
}

.search-container .suggestions {
  position: absolute;
  width: 100%;
  margin: 0;
  padding: 0;
  list-style: none;
  background: var(--surface);
  border: 1px solid var(--line);
  border-radius: var(--radius-md);
  box-shadow: var(--shadow-md);
  z-index: 999;
}

.suggestions li {
  cursor: pointer;
  pointer-events: all !important;
  text-transform: capitalize;
  padding: 0.5em 0.75em;
  font-style: normal;
  font-weight: 500;
  font-size: var(--fs-body);
  line-height: 1.4;
  letter-spacing: 0;
  color: var(--text);
  border-bottom: 1px solid var(--line);
}
.suggestions li:last-child {
  border: 0;
}

.suggestions li:hover {
  background: var(--accent-050);
  color: var(--accent-600);
}

.input--margin {
  margin-top: 10px;
}
.input--wrrapper {
  border: 1px solid var(--line);
  border-radius: var(--radius-md);
  height: 36px;
  background: var(--surface);
  overflow: hidden;
  transition: border-color var(--dur) var(--ease),
    box-shadow var(--dur) var(--ease);
}
.input--wrrapper:focus-within {
  border-color: var(--accent-600);
  box-shadow: var(--ring);
}
.input--wrrapper .reset-icon {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--muted-soft);
  padding: 0 6px;
}
.input--wrrapper .input--icon {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: stretch;
  width: 36px;
  color: var(--muted);
  background: var(--surface-2);
  border-left: 1px solid var(--line);
  padding: 0;
  box-sizing: border-box;
  transition: color var(--dur) var(--ease), background var(--dur) var(--ease);
}
.input--wrrapper .input--icon:hover {
  color: var(--accent-600);
  background: var(--accent-050);
}
.is-active {
  padding-left: 40px !important;
}
input::placeholder {
  font-style: normal;
  font-weight: 400;
  font-size: var(--fs-body);
  line-height: 1.4;
  letter-spacing: 0;
  color: var(--muted-soft);
}
input:disabled {
  background: var(--surface-2);
}
.search-container .isLoading {
  margin-right: 8px;
  border: 4px solid var(--line);
  border-radius: 50%;
  border-top: 4px solid var(--accent-500);
  width: 15px;
  height: 15px;
  -webkit-animation: spin-data-v-54844eca 1s linear infinite;
  animation: spin-data-v-54844eca 1s linear infinite;
}

/* Safari */
@-webkit-keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
